<template>
    <!-- 风格测试 -->
    <div class="item-box">
        <div class="top-line">
            <div class="tit">内容发布</div>
            <div class="right" v-if="active == '999' && list.length == 4">
                <el-button type="text" @click="handleCheckTab()" size="mini">
                    查看更多
                </el-button>
            </div>
        </div>
        <div class="infor-item">
            <sc-table-v2
                v-if="active == '4' || list.length"
                :head="tableHead"
                :data="list"
                :page="page"
                :page-hide="pageHide"
                :read-table="true"
                :load="load"
                :pop-show="false"
                :show-add="false"
                :table-height="tableHeightCalc"
                :selection="false"
                ref="refTable"
                @pageChange="pageChange"
                @pageSizesChange="pageSizesChange"
            >
                <template v-slot:control>
                    <el-table-column label="操作" fixed="right" width="100">
                        <template slot-scope="scope">
                            <sc-qrcode-popover
                                :id="scope.row.id"
                                :type="scope.row.contentType == 1 ? 'article' : 'exhibit'"
                            ></sc-qrcode-popover>
                        </template>
                    </el-table-column>
                </template>
            </sc-table-v2>
        </div>
    </div>
</template>
<script>
import { getUserWorksList } from '@/api/mkt/user.js';

export default {
    name: 'browse-list',
    props: {
        tabActive: {
            type: String,
            default: '',
        },
    },
    watch: {
        tabActive: {
            immediate: true,
            handler(newVal) {
                this.list = [];
                this.active = newVal;
                if (newVal == '999') {
                    this.tableHeightCalc = null;
                    this.page.size = 4;
                    this.pageHide = true;
                } else if (newVal == '4') {
                    this.tableHeightCalc = window.innerHeight - 500;
                    this.page.size = 30;
                    this.pageHide = false;
                }
                if (this.$route.query.token) {
                    setTimeout(async () => {
                        this.getUserWorksList();
                    }, 800);
                } else {
                    this.getUserWorksList();
                }
            },
        },
    },
    data() {
        return {
            active: '',
            load: false,
            pageHide: true,
            tableHead: [
                { name: '发布时间', key: 'createTime' },
                { name: '内容类型', key: 'content' },
                { name: '内容名称', key: 'title' },
                { name: '操作', key: 'control' },
            ],
            tableHeightCalc: null,
            page: {
                size: 4,
                page: 1,
                count: 0,
            },
            list: [],
        };
    },

    methods: {
        async getUserWorksList() {
            this.load = true;
            let params = {
                page: this.page.page,
                size: this.page.size,
                accountId: this.$route.query.accountId,
            };
            let { code, data } = await getUserWorksList(params);
            if (code === 200) {
                this.load = false;
                data.children.forEach(ele => {
                    ele.content = ele.contentType == 1 ? '笔记' : '案例';
                });
                this.list = data.children;
                this.page.count = data.total;
                data.total && this.$emit('setTabNum', { type: 4, num: data.total });
            } else {
                this.load = false;
            }
        },
        pageChange(val) {
            this.page.page = val;
            this.getUserWorksList();
            this.$nextTick(() => {
                this.$refs.refTable.$refs['table-box'].bodyWrapper.scrollTop = 0;
            });
        },
        pageSizesChange(val) {
            this.page.size = val;
            this.getUserWorksList();
        },
        // 切换tab
        handleCheckTab() {
            this.$parent.handleClick({ label: '内容发布', name: '4' });
        },
    },
};
</script>

<style lang="less" scoped>
.item-box {
    margin-bottom: 20px;
    .top-line {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d7d7d7;
        line-height: 34px;
        .tit {
            color: #d9001b;
        }
    }
    .infor-item {
        margin-top: 10px;
    }
}
</style>
